import { jsx } from "react/jsx-runtime";
const KEYS = [1, 2, 3, 4, 5, 6, 7, 8, 9, "PREV", 0, "NEXT"];
function AiqKeypad({ onInput, onPrev, onNext, canPrev, canNext, disabled = false }) {
  return /* @__PURE__ */ jsx("div", { className: "fixed bottom-14 left-1/2 z-40 w-full max-w-[720px] -translate-x-1/2 border-t border-[#eceff5] bg-white px-3 py-4 [box-shadow:0px_-4px_4px_0px_rgb(0_0_0/0.05)]", children: /* @__PURE__ */ jsx("div", { className: "grid grid-cols-3 gap-2", children: KEYS.map((k, i) => {
    if (k === "PREV" || k === "NEXT") {
      const isPrev = k === "PREV";
      const enabled = isPrev ? canPrev : canNext;
      return /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          disabled: disabled || !enabled,
          onClick: isPrev ? onPrev : onNext,
          "aria-label": isPrev ? "이전 빈칸" : "다음 빈칸",
          className: "flex h-12 items-center justify-center rounded-lg bg-lc-v3-gray-100 text-lc-text-secondary transition-colors active:bg-lc-key-50 active:text-lc-key-500 disabled:opacity-30",
          children: /* @__PURE__ */ jsx("span", { "aria-hidden": "true", className: "text-lc-v3-h5 font-semibold", children: isPrev ? "<" : ">" })
        },
        `nav-${i}`
      );
    }
    return /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        disabled,
        onClick: () => onInput(String(k)),
        className: "h-12 rounded-lg bg-lc-v3-gray-100 text-lc-v3-h5 font-semibold text-lc-text-secondary transition-colors active:bg-lc-key-50 active:text-lc-key-500 disabled:opacity-50",
        children: k
      },
      `key-${k}`
    );
  }) }) });
}
export {
  AiqKeypad
};
//# sourceMappingURL=aiq-keypad.js.map
